export const LIST = "AGENT_PAYOUT_LIST";
export const DROPDOWN = "AGENT_PAYOUT_DROPDOWN";
export const HISTORY = "AGENT_PAYOUT_HISTORY";
export const BET_DETAILS = "AGENT_PAYOUT_BET_DETAILS";
export const DEDUCT_DETAILS = "AGENT_PAYOUT_DEDUCT_DETAILS";
export const STORE = "AGENT_PAYOUT_STORE";
export const HISTORY_DETAILS = "AGENT_PAYOUT_HISTORY_DETAILS";
export const DOWNLINE_AGENT_PAYOUT_DETAILS = "AGENT_PAYOUT_DOWNLINE_AGENT_PAYOUT_DETAILS";
export const DOWNLINE_AGENT_PAYOUT_HISTORY_DETAILS = "AGENT_PAYOUT_DOWNLINE_AGENT_PAYOUT_HISTORY_DETAILS";
